const ROUTES = [
    [/^\/goals\/([^/]+)/, "goal_detail", "goal"],
    [/^\/goals$/, "goals"],
    [/^\/projects\/([^/]+)/, "project_detail", "project"],
    [/^\/projects$/, "projects"],
    [/^\/tasks\/([^/]+)/, "task_detail", "task"],
    [/^\/tasks$/, "tasks"],
    [/^\/teams\/([^/]+)/, "team_detail", "team"],
    [/^\/teams$/, "teams"],
    [/^\/reports\/([^/]+)/, "reports", "report"],
    [/^\/reports$/, "reports"],
    [/^\/ai$/, "ai_command_center"],
    [/^\/home$/, "workspace_dashboard"],
];

export function resolveAiPageContext(pathname) {
    for (const [pattern, pageType, entityType] of ROUTES) {
        const match = String(pathname || "").match(pattern);
        if (match) {
            return {
                contextVersion: 1,
                pageType,
                entityType: entityType || null,
                entityDocumentId: entityType ? match[1] : null,
            };
        }
    }
    return {contextVersion: 1, pageType: "workspace_dashboard", entityType: null, entityDocumentId: null};
}
